import { Typography } from '@mui/material';

export const About = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom component="div">
        Learning React with Typescript
      </Typography>
    </>
  );
};
